<template>
	<div class="profile">
		<p>COMPANY PROFILE</p>
		<h3>公司简介</h3>
		<div class="container">
			<div class="content clearfix">
				<div v-html="introduce"></div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'profile',
				introduce:''
			}
		},
		methods:{
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.introduceApi,
				})
				.then((res) => {
					this.introduce = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.$parent.getItem();
			this.getData();
		}
	}
</script>

<style lang="less" scoped="scoped">
.profile{
	P{
		margin-top: 50px;
		font-size: 26px;
		color: #00A0FF;
		text-align:center;
	}
	h3{
		margin-top: 10px;
		font-size: 26px;
		font-weight: 600;
		margin-bottom: 50px;
		text-align:center;
	}
	.content{
		margin-top: 20px;
		margin-top: 20px;
		p{
			margin-bottom: 50px;
			font-size: 15px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/Acom/Profile.vue